import { InputAdornment, Stack, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useState } from 'react';
import { IwImageCommandOptions, wImageCommandOptions } from '../WImageExtension';
import { CommandForm, ICommandFormProps } from '../../../components';

export interface IWImageFormProps extends Omit<ICommandFormProps, 'children' | 'fields'> {
  initialOption?: string;
  initialValues?: any;
  onRemove?: () => void;
}

export const ToggleWImageForm = (props: IWImageFormProps) => {
  const { initialOption, onSubmit, ...rest } = props;
  const [selectedOption, setSelectedOption] = useState<IwImageCommandOptions>(
    wImageCommandOptions.find((item) => item.prefix === initialOption) || wImageCommandOptions[0],
  );
  const handleSelectType = (e: React.MouseEvent<HTMLElement>, newOption: any) => {
    setSelectedOption(wImageCommandOptions.find((item) => item.prefix === newOption.prefix) || wImageCommandOptions[0]);
  };

  const handleSubmit = (values) => {
    const transformValues = {
      ...values,
      [selectedOption.attrs[0]]: `${selectedOption.prefix}${values[selectedOption.attrs[0]]}`,
    };
    onSubmit && onSubmit(transformValues);
  };

  return (
    <Stack spacing={1} direction="column">
      {wImageCommandOptions.length > 1 && (
        <ToggleButtonGroup
          size="small"
          value={selectedOption}
          exclusive
          onChange={handleSelectType}
          aria-label="wImage types"
        >
          {wImageCommandOptions.map((option) => {
            return (
              <ToggleButton
                key={`wImage-type-${option.title}`}
                color="primary"
                value={option}
                aria-label={option.title}
                sx={{ lineHeight: 'unset' }}
              >
                {option.title}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      )}
      <CommandForm name="wImage" onSubmit={handleSubmit} {...rest}>
        {selectedOption.attrs.map((field, key) => {
          return (
            <TextField
              key={`${field}-${key}`}
              name={field}
              size="small"
              label={field}
              variant="standard"
              id="outlined-start-adornment"
              InputProps={
                field === 'src'
                  ? {
                      startAdornment: <InputAdornment position="start">{selectedOption.prefix}</InputAdornment>,
                    }
                  : {}
              }
            />
          );
        })}
      </CommandForm>
    </Stack>
  );
};
